import React from 'react';

import './newBox.css';


function NewBox() {
    return (
      <div className = "newbox">
        <a className = "body__newbox-refl">Написать</a>
      </div>
    );
}

export default NewBox;